import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Clock } from 'lucide-react';
import { toast } from '../hooks/use-toast';

/* Shared tile: routes when `route` exists, otherwise an honest "coming soon" state (never a dead tile). */
export const FeatureTile = ({ item, icon: Icon, gradient, className = '', testId, children }) => {
  const cls = `relative overflow-hidden rounded-2xl p-4 text-white shadow-md bg-gradient-to-br ${gradient} min-h-[110px] flex flex-col justify-between hover:scale-[1.03] active:scale-[0.98] transition-transform cursor-pointer ${className}`;
  const body = children || (
    <>
      <div className="w-9 h-9 rounded-xl bg-white/20 backdrop-blur flex items-center justify-center"><Icon size={18} /></div>
      <div>
        <div className="font-bold text-sm leading-tight">{item.title}</div>
        <div className="text-[10px] text-white/85">{item.titleEn}</div>
      </div>
    </>
  );
  if (item.route) {
    return (
      <Link to={item.route} className={cls} data-testid={testId}>
        {item.external && <span className="absolute top-2 right-2 text-[9px] font-bold bg-white/90 text-gray-800 px-1.5 py-0.5 rounded-full flex items-center gap-0.5"><ExternalLink size={9} /> Official</span>}
        {body}
      </Link>
    );
  }
  return (
    <button type="button" data-testid={testId} className={`${cls} text-left opacity-80`}
      onClick={() => toast({ title: `${item.title} — ଶୀଘ୍ର ଆସୁଛି`, description: 'ଏହି ବିଭାଗ ପାଇଁ ବିଷୟବସ୍ତୁ ଏପର୍ଯ୍ୟନ୍ତ ଯୋଡ଼ା ହୋଇନାହିଁ। Admin CMS ରୁ ପ୍ରକୃତ ସାମଗ୍ରୀ ଅପଲୋଡ୍ ହେଲେ ଏଠାରେ ଦେଖାଯିବ।' })}>
      <span className="absolute top-2 right-2 text-[9px] font-bold bg-white/90 text-gray-800 px-1.5 py-0.5 rounded-full flex items-center gap-0.5"><Clock size={9} /> ଶୀଘ୍ର ଆସୁଛି</span>
      {body}
    </button>
  );
};
